module.exports = __webpack_public_path__ + "img/aerialito-red.0e7b37cc.svg";